(function(app) {

    app.constant("transactionStages",
    [
        "Initiate",
        "Disclose",
        "Capture",
        "Determine",
        "Application",
        "Review"
    ]);

})(window.app);